import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";
import task04 from "./layouts/task-04/task";

const lesson: Lesson = {
  id: "245e1400-a30e-4a82-ad58-b9067687fa9a",
  publicId: "9",
  name: "Ray tracing",
  difficulty: 2,
  contentTypes: { audio: false, interactive: true, video: true },
  body: [principle01, principle02, principle03, task01, task02, task03, task04],
};

export default lesson;
